/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Diff_Type_DeletedInputs */



/**
* | output |
* | --- |
* | "deleted" |
*
* @param {Compare_Event_Groups_Diff_Type_DeletedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_diff_type_deleted = /** @type {((inputs?: Compare_Event_Groups_Diff_Type_DeletedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Diff_Type_DeletedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("supprimé")
	if (locale === "de") return /** @type {LocalizedString} */ ("gelöscht")
	if (locale === "it") return /** @type {LocalizedString} */ ("cancellato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("удалено")
	if (locale === "es") return /** @type {LocalizedString} */ ("eliminado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("已删除")
	if (locale === "ja") return /** @type {LocalizedString} */ ("削除済み")
	if (locale === "hi") return /** @type {LocalizedString} */ ("हटाए गए")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("deletado")
	return /** @type {LocalizedString} */ ("deleted")
});